
/**
 * Component to display when no content is available
 */
const ContentEmpty = () => {
  // Check if we're on homepage
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  
  // Don't show anything on homepage
  if (isHomepage) {
    console.log("ContentEmpty: On homepage, not showing empty state");
    return null;
  }
  
  return (
    <div className="p-4 border border-amber-200 bg-amber-50 rounded-md">
      <h3 className="font-medium mb-2">No content available</h3>
      <p className="text-sm text-muted-foreground">
        The content for this article could not be loaded. Please try refreshing the page.
      </p>
    </div>
  );
};

export default ContentEmpty;
